/* actions.icon.svg.js */

module.exports = {
    icon: `
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <path class="foreground-gl" d="M14.7,16H3.1c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h11.6c0.2,0,0.4-0.2,0.4-0.4V3.1c0-0.2,0.2-0.4,0.4-0.4
                S16,2.8,16,3.1v11.6C16,15.4,15.4,16,14.7,16z"/>
            <g>
                <path class="foreground-gl" d="M12,0H1.3C0.6,0,0,0.6,0,1.3V12c0,0.7,0.6,1.3,1.3,1.3H12c0.7,0,1.3-0.6,1.3-1.3V1.3C13.3,0.6,12.7,0,12,0z
                     M9.9,10.8H9.4c-0.2,0-0.3-0.1-0.3-0.3L8.2,8.2h-3l-0.9,2.3c-0.1,0.2-0.1,0.3-0.3,0.3H3.4c-0.3,0-0.3-0.1-0.2-0.3l2.9-7.6
                    c0.1-0.2,0.1-0.3,0.3-0.3h0.5c0.3,0,0.3,0.1,0.3,0.3l2.9,7.6C10.2,10.7,10.2,10.8,9.9,10.8z"/>
                <polygon class="foreground-gl" points="6.6,4.1 5.5,7.3 7.9,7.3 6.7,4.1 	"/>
            </g>
            </svg>
        `
};
